module.exports = __webpack_public_path__ + "static/media/N60.668f1f27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N60.svg
// module id = 197
// module chunks = 0